import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { managerList, changeState, deleteDeployment } from "@/api/flow/flow";
import { flowCategory } from "@/util/flow";
export default {
  data: function data() {
    return {
      form: {},
      mode: '1',
      selectionId: '',
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      flowBox: false,
      flowUrl: '',
      stateBox: false,
      flowState: '',
      stateOptions: [{
        value: 'active',
        label: '激活'
      }, {
        value: 'suspend',
        label: '挂起'
      }],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        dialogWidth: 900,
        menuWidth: 150,
        dialogClickModal: false,
        column: [{
          label: '租户编号',
          prop: 'tenantId',
          slot: true,
          width: 120
        }, {
          label: '流程主键',
          prop: 'id'
        }, {
          label: '流程标识',
          prop: 'key',
          search: true,
          width: 150
        }, {
          label: '流程名称',
          prop: 'name',
          width: 150
        }, {
          label: "流程分类",
          type: "select",
          row: true,
          dicUrl: "/api/blade-system/dict/dictionary?code=flow",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          slot: true,
          prop: "category",
          search: true,
          width: 100
        }, {
          label: '流程版本',
          prop: 'version',
          slot: true,
          width: 80
        }, {
          label: '状态',
          prop: 'suspensionState',
          slot: true,
          width: 80
        }, {
          label: '部署时间',
          prop: 'deploymentTime',
          width: 165
        }]
      },
      data: []
    };
  },
  watch: {
    'mode': function mode() {
      this.onLoad(this.page);
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        delBtn: this.vaildData(this.permission.flow_manager_remove, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    deploymentIds: function deploymentIds() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.deploymentId);
      });
      return ids.join(",");
    }
  }),
  methods: {
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return deleteDeployment(_this.deploymentIds);
      }).then(function () {
        _this.$message({
          type: "success",
          message: "操作成功!"
        });

        _this.$refs.crud.toggleSelection();

        _this.onLoad(_this.page);
      });
    },
    handleSlotDelete: function handleSlotDelete(row) {
      var _this2 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return deleteDeployment(row.deploymentId);
      }).then(function () {
        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        _this2.$refs.crud.toggleSelection();

        _this2.onLoad(_this2.page);
      });
    },
    handleState: function handleState(row) {
      this.stateBox = true;
      this.selectionId = row.id;
    },
    handleDoState: function handleDoState() {
      var _this3 = this;

      if (!this.flowState) {
        this.$message({
          type: "warn",
          message: "请先选择流程状态!"
        });
        return;
      }

      changeState({
        processId: this.selectionId,
        state: this.flowState
      }).then(function (res) {
        var data = res.data;

        if (data.success) {
          _this3.$message({
            type: "success",
            message: data.msg
          });

          _this3.stateBox = false;

          _this3.onLoad(_this3.page);
        } else {
          _this3.$message({
            type: "warn",
            message: data.msg
          });
        }
      });
    },
    handleImage: function handleImage(row) {
      this.flowUrl = "/api/blade-flow/process/resource-view?processDefinitionId=".concat(row.id);
      this.flowBox = true;
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this4 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var values = _objectSpread(_objectSpread({}, params), {}, {
        category: params.category ? flowCategory(params.category) : null,
        mode: this.mode
      });

      this.loading = true;
      managerList(page.currentPage, page.pageSize, Object.assign(values, this.query)).then(function (res) {
        var data = res.data.data;
        _this4.page.total = data.total;
        _this4.data = data.records;
        _this4.loading = false;

        _this4.selectionClear();
      });
    }
  }
};